// First-party site-wide traffic tracking: fires once per browser session so the admin
// analytics dashboard can show where visits to the app as a whole came from (LinkedIn,
// Instagram, Google, direct, email, ...) — separate from the per-blog-post tracking in
// blogAnalytics.js. Fires against the backend's public tracking endpoint — anonymous, no
// auth required.

const BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:1111";
const PLATFORM = "map_my_pay_app";

const VISITOR_ID_KEY = "mmp_site_visitor_id";
const SESSION_ID_KEY = "mmp_site_session_id";
const SESSION_TRACKED_KEY = "mmp_site_visit_tracked";

function generateId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `id-${Date.now()}-${Math.random()
    .toString(16)
    .slice(2)}`;
}

function getVisitorId() {
  try {
    let id = window.localStorage.getItem(VISITOR_ID_KEY);
    if (!id) {
      id = generateId();
      window.localStorage.setItem(VISITOR_ID_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
}

function getSessionId() {
  try {
    let id = window.sessionStorage.getItem(SESSION_ID_KEY);
    if (!id) {
      id = generateId();
      window.sessionStorage.setItem(SESSION_ID_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
}

function hasAlreadyTrackedThisSession() {
  try {
    return window.sessionStorage.getItem(SESSION_TRACKED_KEY) === "1";
  } catch {
    return false;
  }
}

function markTrackedThisSession() {
  try {
    window.sessionStorage.setItem(SESSION_TRACKED_KEY, "1");
  } catch {
    // ignore
  }
}

function postJson(url, body) {
  fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
    keepalive: true,
  }).catch(() => {
    // Analytics must never break the app — swallow errors.
  });
}

// Fires once per browser session, from wherever the visitor lands first.
export function trackSiteVisit() {
  if (hasAlreadyTrackedThisSession()) return;
  markTrackedThisSession();

  const params = new URLSearchParams(window.location.search);

  postJson(`${BASE_URL.replace(/\/$/, "")}/public/site/visit`, {
    visitor_id: getVisitorId(),
    session_id: getSessionId(),
    platform: PLATFORM,
    landing_path: window.location.pathname,
    referrer_url: document.referrer || undefined,
    utm_source: params.get("utm_source") || undefined,
    utm_medium: params.get("utm_medium") || undefined,
    utm_campaign: params.get("utm_campaign") || undefined,
    utm_content: params.get("utm_content") || undefined,
    utm_term: params.get("utm_term") || undefined,
  });
}
